import { render, staticRenderFns } from "./ElegiacInformation.vue?vue&type=template&id=c3110ee4&scoped=true"
import script from "./ElegiacInformation.vue?vue&type=script&lang=js"
export * from "./ElegiacInformation.vue?vue&type=script&lang=js"
import style0 from "./ElegiacInformation.vue?vue&type=style&index=0&id=c3110ee4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3110ee4",
  null
  
)

export default component.exports